import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { FunctionRegistryService } from '../../../function-registry/function-registry.service';
import { EducationalPathDTO } from '../../../../dto/educational-path/educational-path.dto';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';

export function educationalPaths(componentDataSourceService: ComponentDataSourceService, functionRegistryService: FunctionRegistryService) {
  const openEducationalPath = (row: { guid: string }) => {
    functionRegistryService.executeFunction('navigateTo', ['uddannelsesvej/' + row.guid]);
  };

  return {
    name: 'Educational Paths',
    description: 'Lists all educational paths',
    execute: (params?: LoadDataParams) => {
      
      // Log the search parameters specifically
      if (params?.searchQuery) {
      } else {
      }
      
      // Log the sort parameters specifically
      if (params?.sort) {
      } else {
      }
      
      // Log all params for debugging
      
      // Use the new GET approach with query parameters like other data sources
      return componentDataSourceService['loadDataWithStandardFiltersGET']('educational_paths', '/paths', params).pipe(
        catchError(error => {
          console.error('[Educational Paths DataSource] Error fetching educational paths:', error);
          return of({ items: [], totalCount: 0 });
        }),
        map(result => {
          if (result && result.items) {
            try {
              const paths = result.items.map((path: EducationalPathDTO) => {
                return {
                  ...path
                };
              });

              return {
                items: paths,
                totalCount: result.totalCount,
                pageSize: result.pageSize,
                pageIndex: result.pageIndex,
                filters: result.filters
              };
            } catch (error) {
              console.error('[Educational Paths DataSource] Error converting educational paths:', error);
              return { items: [], totalCount: 0 };
            }
          } else if (Array.isArray(result)) {
            // Handle case where API returns an array instead of paginated object
            try {
              const paths = result.map((path: EducationalPathDTO) => {
                return {
                  ...path
                };
              });
              
              return {
                items: paths,
                totalCount: paths.length,
                pageSize: paths.length,
                pageIndex: 0
              };
            } catch (error) {
              console.error('[Educational Paths DataSource] Error converting educational paths array:', error);
              return { items: [], totalCount: 0 };
            }
          } else {
            console.error('[Educational Paths DataSource] Unexpected response format:', result);
            return { items: [], totalCount: 0 };
          }
        })
      );
    },
            settings: {
          columns: [
            { key: 'name', header: 'Navn', type: 'text', sortable: true, fill: true, width: '22%', minWidth: '140px' },
            { key: 'full_name', header: 'Fuldt navn', type: 'text', sortable: true, fill: true, width: '36%', minWidth: '220px' },
            { 
              key: 'assigned_users_count', 
              header: 'Antal brandmænd', 
              type: 'number',
              alignment: 'center',
              sortable: true,
              fitContent: true,
              minWidth: '150px'
            },
            { 
              key: 'ok_status_percentage', 
              header: 'STATUS (%)', 
              type: 'text',
              transform: (value: number) => `${value}%`,
              alignment: 'left',
              sortable: true,
              fitContent: true,
              minWidth: '110px'
            },
            { 
              key: 'registered_percentage', 
              header: 'Tilmeldte', 
              type: 'text',
              transform: (value: number, row?: any) => {
                if (value === undefined || value === null) return 'N/A';
                const intendedPercentage = Math.min(100, Math.max(0, value)); // Ensure value is between 0-100
                const participatedPercentage = Math.min(100, Math.max(0, row?.progress_percentage || 0));
                
                return `${intendedPercentage}% (${participatedPercentage}%)`;
              },
              alignment: 'left',
              sortable: true,
              fitContent: true,
              minWidth: '120px'
            },
            {
              key: 'edit',
              header: '',
              type: 'icon-button',
              icon: 'edit',
              buttonText: 'Rediger',
              buttonColor: 'primary',
              alignment: 'center',
              fitContent: true,
              width: '1%',
              maxWidth: '52px',
              action: (row: { guid: string }) => openEducationalPath(row),
            }
          ],
      pageable: true,
      sortable: true,
      searchable: true,
      rowHover: true,
      rowClickable: true,
      onRowClick: (row: { guid: string }) => openEducationalPath(row),
      tableLayout: 'auto',
      defaultSortColumn: 'assigned_users_count',
      defaultSortDirection: 'desc'
    }
  }
} 